
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Notify extends Vue {
    get type() {
        return this.$route.params.type;
    }
}
